import { render, staticRenderFns } from "./colorStyle.vue?vue&type=template&id=61b15bb2&scoped=true&"
import script from "./colorStyle.vue?vue&type=script&lang=js&"
export * from "./colorStyle.vue?vue&type=script&lang=js&"
import style0 from "./colorStyle.vue?vue&type=style&index=0&id=61b15bb2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b15bb2",
  null
  
)

export default component.exports